import Login from './Login';
import AccountSelector from './accountSelector';
import ForgotPassword from './ForgotPassword';
window.LoginComponent = Login;
window.AccountSelectorComponent = AccountSelector;
window.ForgotPasswordComponent = ForgotPassword;
